module.exports = __webpack_public_path__ + "img/known.524d9c74.png";